export function getGroupGameLastActedPlayer(game, playerId) {
    for (const player of game.players) {
        if (player.id === playerId) {
            return player
        }
    }
}

export function slugifyUserName(userName) {
    const nameLower = userName.toLowerCase().trim()
    const eng_abc = "abcdefghijklomnopqrstuvwxyz0123456789"

    const mapping = {
        " ": "-",
        "а": "a",
        "б": "b",
        "в": "v",
        "г": "h",
        "ґ": "g",
        "д": "d",
        "е": "e",
        "є": "ye",
        "ж": "zh",
        "з": "z",
        "и": "y",
        "і": "i",
        "ї": "yi",
        "й": "y",
        "к": "k",
        "л": "l",
        "м": "m",
        "н": "n",
        "о": "o",
        "п": "p",
        "р": "r",
        "с": "s",
        "т": "t",
        "у": "u",
        "ф": "f",
        "х": "kh",
        "ц": "ts",
        "ч": "ch",
        "ш": "sh",
        "щ": "sh"
    }

    let convertedName = [...nameLower].map(
        (char) => {
            if (eng_abc.includes(char)) {
                return char
            }
            return mapping[char] || ""
        }
    ).join("").slice(0, 15)

    while (convertedName.slice(-1) === "-") {
        convertedName = convertedName.slice(0, -1)
    }

    return convertedName
}